const WebCheckInTypes = {
	CREATE_WEB_CHECK_IN_START: 'create_web_check_in_start',
	CREATE_WEB_CHECK_IN_SUCCESS: 'create_web_check_in_success',
	CREATE_WEB_CHECK_IN_FAILURE: 'create_web_check_in_failure',
	FETCH_TODAY_ATTENDANCE_START: 'fetch_today_attendance_start',
	FETCH_TODAY_ATTENDANCE_SUCCESS: 'fetch_today_attendance_success',
	FETCH_TODAY_ATTENDANCE_FAILURE: 'fetch_today_attendance_failure',
	REGULARIZE_ATTENDANCE_START: 'regularize_attendance_start',
	REGULARIZE_ATTENDANCE_SUCCESS: 'regularize_attendance_success',
	REGULARIZE_ATTENDANCE_FAILURE: 'regularize_attendance_failure',
	WEB_CHECK_IN_RESPONSE_CHANGED: 'web_check_in_response_changed',
	WEB_CHECK_IN_RESPONSE_REST_START: 'web_check_in_response_rest_start',

	// Encryption keys (must stay in sync with API)
	CREATE_WEB_CHECK_IN_KEY: 'CreateEmployeeTemporaryAttendanceFromWeb',
	FETCH_TODAY_ATTENDANCE_KEY: 'GetEmployeeAttendanceStatusFromWeb',
	REGULARIZE_ATTENDANCE_KEY: 'RegularizeEmployeeAttendanceFromWeb',
} as const;

export default WebCheckInTypes;
